

<main class="preventivo-page">
  <section class="preventivo-intro">
    <div class="container-xl text-center">
      <p class="intro-eyebrow">PREVENTIVO GRATUITO E SENZA IMPEGNO</p>
      <h1>Parliamo del servizio di cui hai bisogno</h1>
      <p>
        Compila il modulo oppure contatta direttamente la sede più vicina.
        Scegli Pescara o Giulianova per indirizzare la richiesta alla sede di riferimento.
      </p>
    </div>
  </section>

  <section class="container-xl form-section">
    <app-preventivo></app-preventivo>
  </section>

  <section class="contacts-section" aria-labelledby="preventivo-contacts-title">
    <div class="container-xl">
      <div class="contacts-head text-center">
        <h2 id="preventivo-contacts-title">Preferisci contattarci direttamente?</h2>
        <p>Scegli la sede di riferimento: telefono, email e indicazioni sono sempre a portata di mano.</p>
      </div>

      <div class="contacts-grid">
        <article class="office-card card-sami">
          <div class="office-icon"><i class="fa-solid fa-location-dot"></i></div>
          <div>
            <p class="office-label">SEDE DI PESCARA</p>
            <h3>Via Tirino 145, 65125 Pescara</h3>
            <ul>
              <li><i class="fa-solid fa-phone"></i><a href="tel:08554360">085 54360</a></li>
              <li><i class="fa-solid fa-envelope"></i><a href="mailto:info@samipulizie.it">info&#64;samipulizie.it</a></li>
            </ul>
            <a class="office-map" href="https://www.google.com/maps/place/Via+Tirino,+145,+Pescara" target="_blank" rel="noopener noreferrer">
              Apri su Google Maps <span aria-hidden="true">→</span>
            </a>
          </div>
        </article>

        <article class="office-card card-sami">
          <div class="office-icon"><i class="fa-solid fa-location-dot"></i></div>
          <div>
            <p class="office-label">SEDE DI GIULIANOVA</p>
            <h3>Corso Nazario Sauro 118, 64021 Giulianova</h3>
            <ul>
              <li><i class="fa-solid fa-phone"></i><a href="tel:0859155805">085 9155805</a></li>
              <li><i class="fa-solid fa-envelope"></i><a href="mailto:commerciale.te@samipulizie.it">commerciale.te&#64;samipulizie.it</a></li>
            </ul>
            <a class="office-map" href="https://www.google.com/maps/search/?api=1&query=42.7533741%2C13.9669969" target="_blank" rel="noopener noreferrer">
              Apri su Google Maps <span aria-hidden="true">→</span>
            </a>
          </div>
        </article>
      </div>
    </div>
  </section>
</main>
